<template>
    <div v-if="showDialog" class="modal flex-container" ><!-- @click.self="$emit('close')" -->
        <div class="modal-content vertical" :style="style">
            <div class="modal-header">
                <p v-if="title != undefined" class="title"> {{title != null ? title : ''}} </p>
                <div id="mdiv" @click="$emit('close')">
                    <div class="mdiv">
                        <div class="md"></div>
                    </div>
                </div>
            </div>
            <div class="modal-slot">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
const openModals = []

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
const OPEN_DROPDOWN = '.vs--open, .multiselect--active'
const OPEN_DATEPICKER = '.mx-datepicker-popup'

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return

    const topModal = openModals[openModals.length - 1]
    if (topModal == null) return

    const target = event.target
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return
    if (document.querySelector(OPEN_DATEPICKER) != null) return

    topModal.$emit('close')
}

export default {
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen()
            }
        },
    },
    beforeDestroy() {
        this.unregisterOpen()
    },
    computed: {
        style () {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen() {
            if (openModals.includes(this)) return
            openModals.push(this)
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true)
            }
        },
        unregisterOpen() {
            const index = openModals.indexOf(this)
            if (index === -1) return
            openModals.splice(index, 1)
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true)
            }
        }
    }
}
</script>

<style scoped>
.modal {
    position: fixed;
    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),
       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */
    z-index: 110;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    display: block;
    background-color: rgba(0,0,0,0.4);
}

.flex-container {
    height: 100%;
    padding: 0;
    margin: 0;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/* margin: auto zamiast align-items/justify-content: center — modal wyższy od
   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem
   (przy centrowaniu flexem jego górna część wystawała poza ekran). */
.modal-content {
    margin: auto;
    background-color: #fefefe;
    border: unset;
    width: auto;
    z-index: 1000;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0,0,0,0.2);
}

.modal-header {
    background-color:  #34758E;
    width: 100%;
    font-family: "SourceSansProBold", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    color: white;
}

.close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.widthClass {
    max-width: 30%;
}

.modal-slot {
    /* margin-right: 10px;
    margin-left: 10px; */
}

#mdiv {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.mdiv {
  height: 25px;
  width: 2px;
  margin-left: 12px;
  background-color: white;
  transform: rotate(45deg);
  Z-index: 1;
}

.md {
  height: 25px;
  width: 2px;
  background-color: white;
  transform: rotate(90deg);
  Z-index: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue